import React from "react"
import { Box } from "@theme-ui/components"

const SingleColumn = ({ data, multi }) => {
    return (
        <>
            <Box
                sx={{
                    textAlign: data.Text_Alignment || data.text_alignment,
                    clear: "both",
                    flex: 1,
                    // scrollMarginTop: "7.5em",
                    marginX: multi === true ? "0.5rem" : 0,
                }}
                className={"content-margin"}
            >
                {data.title && <h2 className="content-title">{data.title}</h2>}
                <div dangerouslySetInnerHTML={{ __html: data.content }} />
            </Box>
        </>
    )
}

export default SingleColumn
